export function ParallaxDivider({ variant = 1 }) {
  return (
    <div className={`parallax-divider variant-${variant}`}>
      <div className="parallax-line-left" />
      <div className="parallax-diamond" />
      <div className="parallax-line-right" />
    </div>
  );
}
